<template>
  <navbar position="fixed"
          :transparent="transparent"
          :color-on-scroll="colorOnScroll"
          menu-classes="ml-auto">
    <template slot-scope="{toggle, isToggled}">
      <a class="navbar-brand" href="/" style=" -webkit-transition: all 5.5s ease;">
        <div class="logo-container brand">
          <img src="img/forswitch/logo-icon-forswitch.png" alt="ForSwitch logo">
        </div>
        ForSwitch
      </a>
    </template>
    <template slot="navbar-menu" style="padding-top: 20px;">
      <a href="#about" class="nav-item nav-link company-navbar">
        about
      </a>
      <a href="#services" class="nav-item nav-link company-navbar">
        services
      </a>
      <a href="#contact" class="nav-item nav-link company-navbar">
        contact
      </a>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink} from '@/components';
import { Popover } from 'element-ui'
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  methods: {
    scrollMeTo(refName) {
      debugger
      var element = this.$refs[refName];
      debugger
      element.scrollIntoView();
    }
  }
}
</script>

<style scoped>

</style>
